import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import toast from 'react-hot-toast';

import { queryApi } from 'src/api/queryApi';

const DiscardButton = ({ query, mutate }) => {
  const handleDiscardQuery = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const response = await queryApi.updateQuery(query.id, 'discarded');
    if (response.status === 'Query Updated') {
      toast.success('Query discarded successfully');
      mutate();
    } else {
      toast.error('Failed to discard query');
    }
  };

  return (
    <Tooltip title="Discard Query">
      <IconButton
        onClick={(event) => handleDiscardQuery(event)}
        aria-label="discard query"
        size="medium"
        sx={{
          ml: 1.5,
          backgroundColor: 'neutral.200',
          color: 'neutral.700',
          '&:hover': {
            backgroundColor: 'error.light',
            color: 'error.main',
          },
          width: 40,
          height: 40,
        }}
      >
        <Close fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

DiscardButton.propTypes = {
  query: PropTypes.object.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default DiscardButton;
